import {BaseCart, CartItem, CartItemQuery} from '@eastsideco/salvo-ts';


export default class Cart extends BaseCart

{
    constructor() {
        super();
    }

    getCartItemCount() {
        let itemCount = 0;
        for (const item of cart.items) {
            itemCount += item.quantity;
        }
        return itemCount;
    }

    checkCart(variant: number) {
        return (cart.items.filter((item) => ~~item.variantId === ~~variant)).length > 0;
    }
}

export const cart = new Cart();
cart.reload().catch((event: unknown | null) => {
    if (event instanceof Error) {
        // this.$log.error(event.message);
    }
});
